import { useReducer, useCallback } from 'react';
import { UIState, UIAction } from '../types';

// Initial UI state
export const initialUIState: UIState = {
	isHovering           : false,
	isUploadDialogOpen   : false,
	isCategorySelectOpen : false,
	isDeleteDialogOpen   : false,
	isCropDialogOpen     : false,
	isReplacingThumbnail : false
};

// UI reducer function
const uiReducer = (state: UIState, action: UIAction): UIState =>
{
	switch (action.type)
	{
		case 'UPDATE_UI':
			return {
				...state,
				[action.field] : action.value
			};
		case 'RESET_UI':
			return initialUIState;
		default:
			return state;
	}
};

export const useUIState = () =>
{
	const [ uiState, dispatchUI ] = useReducer(uiReducer, initialUIState);

	const handleUIUpdate = useCallback((field: keyof UIState, value: boolean) =>
	{
		dispatchUI({ type: 'UPDATE_UI', field, value });
	}, []);

	return {
		uiState,
		dispatchUI,
		handleUIUpdate
	};
};